/**
 *
 * RequestedTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import InactiveIcon from 'assets/v2/InactiveIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.mediumPurpleDark};
    background: ${COLORS.mediumPurpleLight};
    border-color: ${COLORS.mediumPurple};
    border-radius: ${({ $borderRadius, theme }) => $borderRadius || theme.borderRadius.secondary};;

    &&& .MuiChip-icon path {
      fill: ${COLORS.mediumPurple};
    }
  }
`;

function RequestedTag(props) {
  return <StyledTag label="Requested" icon={<InactiveIcon />} {...props} />;
}

export default memo(RequestedTag);
